import { render, staticRenderFns } from "./courseblog.vue?vue&type=template&id=40ba8282&scoped=true&"
import script from "./courseblog.vue?vue&type=script&lang=js&"
export * from "./courseblog.vue?vue&type=script&lang=js&"
import style0 from "./courseblog.vue?vue&type=style&index=0&id=40ba8282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ba8282",
  null
  
)

export default component.exports